// Additional data: fundraising pipeline, stories of change, resource utilisation

export const STAGES = [
  { key: 'conversation', label: 'In Conversation',        prob: 0.20, color: '#BDD7E7' },
  { key: 'submitted',    label: 'Proposal Submitted',     prob: 0.45, color: '#6BAED6' },
  { key: 'provisional',  label: 'Provisionally Approved', prob: 0.75, color: '#2171B5' },
  { key: 'converted',    label: 'Converted',              prob: 1.00, color: '#08519C' },
];

// kind:'Renewal' = existing donor account being renewed
export const PIPELINE = [
  // In Conversation
  { org: 'Infosys Foundation',       program: 'education',  city: 'Bengaluru', val: 5.4, stage: 'conversation', owner: 'Meera Nair',    days: 12, close: '2026-11-30' },
  { org: 'Deutsche Bank AG',         program: 'education',  city: 'Delhi NCR', val: 4.2, stage: 'conversation', owner: 'Rohit Sharma',  days: 34, close: '2026-11-30', kind: 'Renewal' },
  { org: 'Google.org',               program: 'education',  city: 'Bengaluru', val: 7.5, stage: 'conversation', owner: 'Arjun Sethi',   days: 18, close: '2027-01-31' },
  { org: 'Tata Steel Foundation',    program: 'livelihood', city: 'Mumbai',    val: 3.8, stage: 'conversation', owner: 'Kavita Rao',    days: 41, close: '2026-12-31' },
  { org: 'Microsoft Philanthropies', program: 'education',  city: 'Hyderabad', val: 6.8, stage: 'conversation', owner: 'Arjun Sethi',   days: 22, close: '2027-02-28' },
  { org: 'Bosch India Foundation',   program: 'healthcare', city: 'Bengaluru', val: 3.2, stage: 'conversation', owner: 'Meera Nair',    days:  9, close: '2027-01-15', kind: 'Renewal' },
  { org: 'Maruti Suzuki Foundation', program: 'livelihood', city: 'Delhi NCR', val: 3.5, stage: 'conversation', owner: 'Rohit Sharma',  days: 48, close: '2026-11-15' },
  { org: 'Herbalife Family Fdn',     program: 'women',      city: 'Bengaluru', val: 2.0, stage: 'conversation', owner: 'Meera Nair',    days:  6, close: '2027-02-15' },

  // Proposal Submitted
  { org: 'Adobe Inc.',               program: 'education',  city: 'Bengaluru', val: 3.2, stage: 'submitted', owner: 'Meera Nair',   days: 26, close: '2026-10-31', kind: 'Renewal' },
  { org: 'Pepsico Foundation',       program: 'healthcare', city: 'Delhi NCR', val: 4.6, stage: 'submitted', owner: 'Divya Menon',  days: 33, close: '2026-09-30', kind: 'Renewal' },
  { org: 'Wipro Foundation',         program: 'education',  city: 'Bengaluru', val: 5.5, stage: 'submitted', owner: 'Meera Nair',   days: 38, close: '2026-10-31' },
  { org: 'Accenture India CSR',      program: 'livelihood', city: 'Bengaluru', val: 6.2, stage: 'submitted', owner: 'Meera Nair',   days: 54, close: '2026-09-30' },
  { org: 'Salesforce India',         program: 'education',  city: 'Hyderabad', val: 4.4, stage: 'submitted', owner: 'Arjun Sethi',  days: 29, close: '2026-11-30' },
  { org: 'JSW Foundation',           program: 'livelihood', city: 'Mumbai',    val: 5.0, stage: 'submitted', owner: 'Kavita Rao',   days: 63, close: '2026-09-15' },
  { org: 'Axis Bank Foundation',     program: 'education',  city: 'Mumbai',    val: 4.2, stage: 'submitted', owner: 'Kavita Rao',   days: 41, close: '2026-10-15' },
  { org: 'Bharti Airtel Foundation', program: 'education',  city: 'Delhi NCR', val: 6.8, stage: 'submitted', owner: 'Rohit Sharma', days: 22, close: '2026-11-15' },
  { org: 'Hyundai Motor India Fdn',  program: 'women',      city: 'Chennai',   val: 3.6, stage: 'submitted', owner: 'Divya Menon',  days: 58, close: '2026-09-30' },

  // Provisionally Approved
  { org: 'Cisco Systems India',      program: 'education',  city: 'Bengaluru', val: 3.6, stage: 'provisional', owner: 'Meera Nair',   days: 21, close: '2026-08-31', kind: 'Renewal' },
  { org: 'Qualcomm India',           program: 'education',  city: 'Hyderabad', val: 4.8, stage: 'provisional', owner: 'Arjun Sethi',  days: 15, close: '2026-08-31' },
  { org: 'L&T CSR',                  program: 'livelihood', city: 'Chennai',   val: 4.0, stage: 'provisional', owner: 'Divya Menon',  days: 29, close: '2026-08-15' },
  { org: 'Deloitte India',           program: 'livelihood', city: 'Mumbai',    val: 3.2, stage: 'provisional', owner: 'Kavita Rao',   days: 12, close: '2026-09-30' },
  { org: 'REC Foundation',           program: 'women',      city: 'Delhi NCR', val: 3.8, stage: 'provisional', owner: 'Rohit Sharma', days: 38, close: '2026-08-31' },

  // Converted (this FY)
  { org: 'Berger Paints India',      program: 'livelihood', city: 'Mumbai',    val: 6.2, stage: 'converted', owner: 'Kavita Rao',   days: 0, close: '2026-04-28', kind: 'Renewal' },
  { org: 'HDB Financial Services',   program: 'women',      city: 'Mumbai',    val: 1.2, stage: 'converted', owner: 'Kavita Rao',   days: 0, close: '2026-05-20' },
  { org: 'Wells Fargo India',        program: 'women',      city: 'Hyderabad', val: 2.9, stage: 'converted', owner: 'Arjun Sethi',  days: 0, close: '2026-06-10', kind: 'Renewal' },
  { org: 'Aristocrat Technologies',  program: 'livelihood', city: 'Delhi NCR', val: 1.8, stage: 'converted', owner: 'Rohit Sharma', days: 0, close: '2026-06-25' },
];

export const LOST_THIS_FY = 4;
export const AVG_DAYS_TO_CONVERT = 89;

// ================= STORIES OF CHANGE =================
export const STORIES = {
  published: 42, districts: 34, inDonorReports: 19, mediaPickups: 5,
  items: [
    {
      featured: true, grant: 'G04', state: 'Karnataka', district: 'Yadgir', date: '2026-05-08', author: 'Priya Raman',
      img: 'https://images.pexels.com/photos/36739282/pexels-photo-36739282.jpeg?auto=compress&cs=tinysrgb&w=1200',
      program: 'healthcare', donor: 'Bosch India Foundation', grantName: 'Smile on Wheels — Karnataka',
      title: 'The Doctor Who Comes To The Village on Wednesdays',
      excerpt: 'For 47 villages in the Yadgir taluk, the Smile on Wheels van is the first — and often only — encounter with a qualified physician in a month. This year, 210,000 primary consultations, 61,000 point-of-care tests, and 2,100 women screened for anaemia moved a decade of postponed diagnoses onto a chart.',
      quote: 'Earlier we walked eight kilometres to the PHC and often turned back. Now we mark Wednesdays on the calendar.',
      who: 'Anganwadi worker, Kembhavi village',
    },
    {
      grant: 'G01', state: 'Karnataka', district: 'Bengaluru Urban', date: '2026-05-22', author: 'Mohit Karkare',
      img: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=800&q=70',
      program: 'education', donor: 'Microsoft Corporation', grantName: 'Mission Education Digital Classrooms',
      title: 'Class 8 That Now Owns The Whiteboard',
      excerpt: 'Fifty-four students at the government primary school in Yelahanka now co-run their Wednesday science demos. Attendance is up 14% since the digital classroom went live in November — and the girls have taken over the coding club.',
      quote: 'I explained loops to my father using our ration list. He got it.',
      who: 'Priya, Grade 8',
    },
    {
      grant: 'G12', state: 'Maharashtra', district: 'Aurangabad', date: '2026-06-01', author: 'Sana Iqbal',
      img: 'https://images.unsplash.com/photo-1594736797933-d0501ba2fe65?w=800&q=70',
      program: 'women', donor: 'HDB Financial Services', grantName: 'Micro-Enterprises for Women',
      title: 'Three Sewing Machines, Nine Livelihoods',
      excerpt: 'Lakshmi started with one machine and a group loan. Eighteen months on, her tailoring unit employs three women from her lane, and six more have started units of their own — a quiet multiplier the programme never budgeted for.',
      quote: 'The mentor called every fortnight. That is why I did not give up in month two.',
      who: 'Lakshmi, SHG entrepreneur',
    },
    {
      grant: 'G08', state: 'Karnataka', district: 'Bengaluru Urban', date: '2026-04-15', author: 'Mohit Karkare',
      img: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800&q=70',
      program: 'livelihood', donor: 'Flipkart Foundation', grantName: 'STeP Bengaluru — Youth Skilling',
      title: 'Six Months, First Salary Slip',
      excerpt: 'Twelve tier-2 youth from a single STeP cohort walked into their first jobs this quarter. Average starting salary: ₹22,400. Placement rate for the cohort: 71%, the highest STeP has recorded in Bengaluru.',
      quote: 'The first payslip went to my mother. She kept the paper — not the money.',
      who: 'Sajid, network engineer',
    },
    {
      grant: 'G05', state: 'Telangana', district: 'Warangal', date: '2026-05-30', author: 'Priya Raman',
      img: 'https://images.unsplash.com/photo-1708593337380-6f97a307696f?w=800&q=70',
      program: 'women', donor: 'Wells Fargo India', grantName: 'Swabhiman — Reproductive Health',
      title: 'The Sisterhood That Broke The Silence On Anaemia',
      excerpt: '76,000 women sensitised, 72,000 women screened, and — quieter but larger — 168 accredited social health activists trained to lead conversations that used to be whispered. In Warangal alone, iron-folic-acid coverage moved from 38% to 71% in eighteen months.',
      quote: 'The ASHA didi is now our first phone call, not the last.',
      who: 'Woman leader, Ghanapur',
    },
    {
      grant: 'G02', state: 'Maharashtra', district: 'Pune', date: '2026-05-14', author: 'Sana Iqbal',
      img: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=800&q=70',
      program: 'livelihood', donor: 'Berger Paints India', grantName: 'iTrain — Painters Upskilling',
      title: 'From Daily Wager To Contractor In A Year',
      excerpt: 'Ramesh finished the iTrain module and picked up his first solo contract in October. Ten months later, he leads a five-member team painting mid-rise apartments in Wagholi. Berger\'s upskilling module is now a rite of passage on his site.',
      quote: 'Earlier the contractor decided my rate. Now I quote — and clients ask for me.',
      who: 'Ramesh, iTrain graduate',
    },
  ],
};

// ================= RESOURCE UTILISATION =================
export const ORG = { headcount: 312, charged: 218, salaryRecovery: 76, underAllocated: 14, overAllocated: 5, avgMonthlySalaryL: 0.54 };

// [FTEs charged, people-cost % of grant budget]
export const GRANT_FTE = {
  G01: [22, 42], G02: [18, 48], G03: [14, 46], G04: [26, 44], G05: [12, 49],
  G06: [15, 45], G07: [10, 51], G08: [ 9, 41], G09: [11, 54], G10: [ 7, 38],
  G11: [ 6, 40], G12: [ 5, 47], G13: [ 8, 44], G14: [ 9, 46],
};

export const BAND_ALLOC = {
  bands: ['Field Coordinators','Programme Managers','Trainers','M&E Specialists','Finance & Compliance','Leadership'],
  grants: ['G04','G01','G02','G06','G07','G03'],
  cells: [
    [12, 11, 10, 8, 6, 7],
    [ 4,  4,  3, 3, 3, 3],
    [ 5,  4,  4, 3, 3, 3],
    [ 2,  2,  1, 1, 1, 1],
    [ 1,  1,  1, 1, 1, 1],
    [ 2,  1,  1, 1, 1, 1],
  ],
};

// Named exceptions only (privacy rule)
export const OVER_ALLOC = [
  { name: 'Ritika S.',  role: 'State Programme Manager · MH', alloc: [['G02', 60], ['G04', 55]] },
  { name: 'Devang P.',  role: 'Lead — Digital Classrooms',    alloc: [['G01', 70], ['G10', 45]] },
  { name: 'Farhan M.',  role: 'Regional Manager · South',     alloc: [['G04', 50], ['G06', 40], ['G11', 25]] },
  { name: 'Kirti J.',   role: 'M&E Lead · North',             alloc: [['G03', 65], ['G13', 45]] },
  { name: 'Suresh V.',  role: 'Master Trainer · Livelihood',  alloc: [['G02', 60], ['G08', 45]] },
];

export const UNDER_ALLOC = [
  { name: 'Pooja H.', role: 'Programme Associate · UP',   alloc: [['G07', 40]] },
  { name: 'Rajat B.', role: 'Content Designer',           alloc: [['G10', 35]] },
  { name: 'Imran Q.', role: 'Data Analyst — M&E',         alloc: [['G12', 45]] },
  { name: 'Sneha L.', role: 'Field Coordinator · Odisha', alloc: [['G09', 50]] },
];

// Tranches / invoicing
export const TRANCHES = [
  { grant: 'G04', t: '3 of 4', amt: 1.2, due: '2026-05-28', status: 'To Invoice' },
  { grant: 'G09', t: '3 of 4', amt: 0.7, due: '2026-05-20', status: 'To Invoice' },
  { grant: 'G06', t: '2 of 4', amt: 0.8, due: '2026-06-15', status: 'To Invoice' },
  { grant: 'G11', t: '3 of 4', amt: 0.6, due: '2026-06-25', status: 'To Invoice' },
  { grant: 'G05', t: '2 of 5', amt: 0.7, due: '2026-07-01', status: 'To Invoice' },
  { grant: 'G01', t: '3 of 4', amt: 1.2, due: '2026-07-20', status: 'Invoiced', inv: '2026-06-20' },
  { grant: 'G14', t: '3 of 4', amt: 0.5, due: '2026-07-12', status: 'Invoiced', inv: '2026-06-12' },
  { grant: 'G02', t: '2 of 3', amt: 1.6, due: '2026-07-30', status: 'Invoiced', inv: '2026-06-30' },
  { grant: 'G08', t: '3 of 4', amt: 0.7, due: '2026-08-05', status: 'Invoiced', inv: '2026-07-04' },
  { grant: 'G03', t: '3 of 4', amt: 0.9, due: '2026-04-15', status: 'In Bank', recdOn: '2026-04-18' },
  { grant: 'G07', t: '3 of 4', amt: 0.6, due: '2026-04-20', status: 'In Bank', recdOn: '2026-04-25' },
  { grant: 'G10', t: '2 of 4', amt: 0.4, due: '2026-05-08', status: 'In Bank', recdOn: '2026-05-10' },
  { grant: 'G13', t: '4 of 4', amt: 0.5, due: '2026-03-25', status: 'In Bank', recdOn: '2026-03-28' },
];

export const AWARDS_2024 = [
  'Best CSR Excellence in Healthcare — ASSOCHAM 2024',
  'Most Trusted NGO in Child Development — National Quality Awards 2024',
  'Health-Focused NGO of the Year — CSR Health Awards 2024',
  'Most Impactful NGO of the Year (Education) — CSR Connect Summit 2024',
];
